<!--<script lang="ts" setup>-->
<!--import {IconCrown, IconImage, IconMessenger} from "~/components/ui/icons";-->
<!--import {useI18n} from "vue-i18n";-->

<!--const {t} = useI18n();-->

<!--const props = defineProps<{-->
<!--  profile: { username: string, subscription: { benefits: string[] } }-->
<!--}>();-->

<!--const emit = defineEmits(['subscribe']);-->

<!--function subscribe() {-->
<!--  emit('subscribe');-->
<!--}-->
<!--</script>-->

<!--<template>-->
<!--  <div class="flex flex-col grow p-4 md:p-6 overflow-y-auto">-->
<!--    <SubscriptionBadge :author="profile"/>-->
<!--    <div class="mt-6 md:mb-10">-->
<!--      <h2 class="text-lg font-semibold mb-3">{{ t('subscription.benefits_title') }}</h2>-->
<!--      <ul class="flex flex-col gap-3">-->
<!--        <SubscriptionFeature-->
<!--          v-if="profile.subscription.benefits.includes('subscriber_badge')"-->
<!--          :icon="IconCrown"-->
<!--          :title="t('subscription.benefits.subscriber_badge')"-->
<!--        />-->
<!--        <SubscriptionFeature-->
<!--          v-if="profile.subscription.benefits.includes('special_materials')"-->
<!--          :icon="IconImage"-->
<!--          :title="t('subscription.benefits.special_materials')"-->
<!--        />-->
<!--        <SubscriptionFeature-->
<!--          v-if="profile.subscription.benefits.includes('behind_the_scenes_materials')"-->
<!--          :icon="IconImage"-->
<!--          :title="t('subscription.benefits.behind_the_scenes_materials')"-->
<!--        />-->
<!--        <SubscriptionFeature-->
<!--          v-if="profile.subscription.benefits.includes('social_channel_for_subscribers')"-->
<!--          :icon="IconMessenger"-->
<!--          :title="t('subscription.benefits.social_channel_for_subscribers')"-->
<!--        />-->
<!--      </ul>-->
<!--    </div>-->
<!--    <Button @click="subscribe" class="min-h-9 mt-10 self-end text-white bg-gradient">-->
<!--      {{ t('buttons.subscribe') }}-->
<!--    </Button>-->
<!--  </div>-->
<!--</template>-->

<script lang="ts" setup>
import {IconAddPreview, IconCrown, IconMessenger, IconShare} from "~/components/ui/icons";
import {useI18n} from "vue-i18n";

const props = defineProps<{
  profile: { username: string, subscription: { benefits: string[] } }
}>();

const {t} = useI18n();

const emit = defineEmits(['subscribe']);

function subscribe() {
  emit('subscribe');
}

const benefits = [
  {key: 'subscriber_badge', icon: IconCrown},
  {key: 'special_materials', icon: IconAddPreview},
  {key: 'behind_the_scenes_materials', icon: IconShare},
  {key: 'social_channel_for_subscribers', icon: IconMessenger}
];
</script>
<template>
  <div class="flex flex-col grow p-4 md:p-6 overflow-y-auto">
    <SubscriptionBadge :author="profile"/>
    <div class="mt-6 md:mb-10">
      <h2 class="text-lg font-semibold mb-5 text-center">{{ t('subscription.benefits_title') }}</h2>
      <ul class="flex flex-col gap-3">
        <SubscriptionFeature
          v-for="benefit in benefits"
          :key="benefit.key"
          :icon="benefit.icon"
          :title="t(`subscription.benefits.${benefit.key}`)"
        />
      </ul>
    </div>
    <Button @click="subscribe" class="min-h-9 mt-10 self-end text-white bg-gradient-button">
      {{ t('buttons.subscribe') }}
    </Button>
  </div>
</template>
